export const maldivesMaafushiProgram = {
  programKey: 'malediwy-rajski-reset-na-maafushi',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Malediwy - Rajski reset na Maafushi',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Malediwy:',
  stickySubtitle: 'Rajski reset na Maafushi',

  pageUrl:
    'https://coolturystki.pl/wycieczki/malediwy-rajski-reset-na-maafushi',

  /* Dane marketingowe będzie można uzupełnić podczas pracy nad katalogiem. */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/malediwy-rajski-reset-sandbank-mtbqyaz1.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/malediwy-rajski-reset-sandbank-mtbqyaz1.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Malediwy'],
    continent: 'Azja',
    categories: [],
    travelStyles: ['Wypoczynek', 'Egzotyka'],
    catalogPublishedAt: '2026-08-30',
  },

  /* Każdy termin jest osobnym wyjazdem w Vakanzie. */
  tripIds: [13, 14],

  /*
   * Nie dodajemy priceNote ani priceNotePrice. Dzięki temu pod kartą
   * automatycznie pojawi się pierwsza transza wyliczona z aktualnej ceny.
   */
  termDetails: {
    '13': {
      pilotId: 'paulina',
      group: 'Tylko dla kobiet',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa rozpoczyna podróż na Lotnisku Chopina w Warszawie i leci do Malé. Możliwe jest również rozpoczęcie podróży w Krakowie lub Berlinie.',
        },
        hotel: {
          title: 'Hotel 3★ na Maafushi',
          description:
            'Zakwaterowanie na Maafushi. Pokoje 2-osobowe, śniadania w cenie.',
        },
      },
    },

    '14': {
      pilotId: 'paulina',
      group: 'Tylko dla kobiet',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa rozpoczyna podróż na Lotnisku Chopina w Warszawie i leci do Malé. Możliwe jest również rozpoczęcie podróży w Krakowie lub Berlinie.',
        },
        hotel: {
          title: 'Hotel 3★ na Maafushi',
          description:
            'Zakwaterowanie na Maafushi. Pokoje 2-osobowe, śniadania w cenie.',
        },
      },
    },
  },
}
